import weSkiResortMapping from './resort-mapping.json';
import weSkiRegionMapping from './region-mapping.json';

interface IWeSkiMapping {
  [key: string]: string;
}

const lang = process.env.NEXT_PUBLIC_LANG;

export function weSkiDestinationId({ resortId, regionId } : { resortId?: string, regionId?: string }) {
  if (resortId) {
    return (weSkiResortMapping as IWeSkiMapping)[resortId];
  }

  if (regionId) {
    return (weSkiRegionMapping as IWeSkiMapping)[regionId];
  }
  return null;
}

export function hasWeSkiIntegration({ resortId, regionId } : { resortId?: string, regionId?: string }) {
  return weSkiDestinationId({ resortId, regionId }) && (lang === 'en-GB' || lang === 'en-US');
}
